export const fillerWords = ['oh', 'um', 'uh', 'ah', 'hm', 'hmm'];
